// ============================================================
// TIPOS DE DOCUMENTO
// ============================================================
export const DOCUMENT_TYPES = [
  { id: 1, code: "CC", label: "Cédula de Ciudadanía" },
  { id: 2, code: "CE", label: "Cédula de Extranjería" },
  { id: 3, code: "PPT", label: "Permiso por Protección Temporal" },
  { id: 4, code: "PEP", label: "Permiso Especial de Permanencia" },
  { id: 5, code: "PA", label: "Pasaporte" },
];

export const getDocumentTypeById = (id) => {
  return DOCUMENT_TYPES.find((d) => d.id === Number(id)) || null;
};

export const getDocumentTypeByCode = (code) => {
  return DOCUMENT_TYPES.find((d) => d.code === String(code).toUpperCase()) || null;
};

export default DOCUMENT_TYPES;
